import {h, Fragment} from "preact"
import { usePagination, useActions } from '@nosto/preact'

export default () => {
    const pagination = usePagination({
        width: 5,
    })
    const { updateSearch } = useActions()

    const createCallback = (from) => () => {
        updateSearch({
            products: {
                from,
            },
        })
        scrollTo(0, 0)
    }

    return (
        pagination.pages.length > 1 && (
            <ul class="ns-d-flex ns-flex-wrap ns-justify-content-center ns-list-unstyled ns-m-0 ns-p-0 ns-my-2 ns-mx-0">
                <li class="ns-background-white ns-pagination-li ns-pagination-prev">
                    <a
                        class={`ns-page-link ns-d-block ns-previous ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-border-radius-3 ${
                            !pagination.prev ? 'ns-disabled' : ''
                        }`}
                        href="javascript:void(0)"
                        aria-label="Previous"
                        onClick={pagination.prev ? createCallback(pagination.prev.from) : null}>
                        <span aria-hidden="true">
                            <i class="ns-icon ns-icon-arrow"></i>
                        </span>
                    </a>
                </li>

                {pagination.first && (
                    <li class="ns-background-white ns-pagination-li">
                        <a
                            class="ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-border-radius-3"
                            href="javascript:void(0)"
                            onClick={createCallback(pagination.first.from)}>
                            {pagination.first.page}
                        </a>
                    </li>
                )}

                {pagination.first && (
                    <li class="ns-background-white ns-pagination-li">
                        <span class="ns-d-block ns-py-2 ns-px-4">...</span>
                    </li>
                )}

                {pagination.pages.map((page) => (
                    <>
                        <li
                            class={`ns-background-white ns-pagination-li ${
                                page.current ? 'ns-pagination-active' : ''
                            }`}>
                            <a
                                class="ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-border-radius-3"
                                href="javascript:void(0)"
                                onClick={createCallback(page.from)}>
                                {page.page}
                            </a>
                        </li>
                    </>
                ))}
                {pagination.last && (
                    <li class="ns-background-white ns-pagination-li">
                        <span class="ns-py-2 ns-px-4">...</span>
                    </li>
                )}
                {pagination.last && (
                    <li class="ns-background-white ns-pagination-li">
                        <a
                            class="ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-border-radius-3"
                            href="javascript:void(0)"
                            onClick={createCallback(pagination.last.from)}>
                            {pagination.last.page}
                        </a>
                    </li>
                )}
                <li class="ns-background-white ns-pagination-li ns-pagination-next">
                    <a
                        class={`ns-page-link ns-d-block ns-next ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-border-radius-3 ${
                            !pagination.next ? 'ns-disabled' : ''
                        }`}
                        href="javascript:void(0)"
                        aria-label="Next"
                        onClick={pagination.next ? createCallback(pagination.next.from) : null}>
                        <span aria-hidden="true">
                            <i class="ns-icon ns-icon-arrow"></i>
                        </span>
                    </a>
                </li>
            </ul>
        )
    )
}
